import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row, Divider } from 'antd';
import { ExcelIcon } from 'icons';
import { Link, Route, Routes, useNavigate } from 'react-router-dom';
import DeleteModal from 'components/deleteModalView';
import Filters from 'components/filters';
import useExtraSales from '../useExtraSales';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { getPage } from '../../../../../hooks/useUser';

const ExtraSalesMainPage = () => {
  const { t } = useTranslation();
  const {
    columns,
    data,
    filters,
    onDelete,
    updateInProcess,
    loading,
    onChangeTableFilter,
    handleDownloadExcel,
  } = useExtraSales();
  const navigate = useNavigate();
  const pages = useRecoilValue(getPage);

  const handleOnRow = useCallback(
    (record, rowIndex) => {
      return {
        onClick: () => {
          navigate(`${record.id}`);
        },
      };
    },
    [navigate],
  );
  return (
    <>
      <PageHeader title={t('Attività per fascia oraria').toUpperCase()}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              loading={updateInProcess}
              onClick={handleDownloadExcel}
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
            >
              {t('Export')}
            </Button>
          </Col>
          {pages?.ability?.can_create && (
            <Col>
              <Link to={'new'}>
                <Button width={'138px'} big icon={<PlusOutlined />}>
                  {t('NUOVO')}
                </Button>
              </Link>
            </Col>
          )}
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters filters={filters} />
        <Divider />
        <Table
          columns={columns}
          dataSource={data.extrasales}
          pagination={data.pagination}
          loading={loading}
          onChange={onChangeTableFilter}
          onRow={handleOnRow}
          scroll={{ x: 1000 }}
        // bordered
        />
      </div>
      <Routes>
        <Route
          path={':id/delete'}
          element={
            <DeleteModal loading={updateInProcess} onClickDelete={onDelete} />
          }
        />
      </Routes>
    </>
  );
};

export default ExtraSalesMainPage;
